import { render } from "./Datenschutz.vue?vue&type=template&id=2585f282&ts=true"
import script from "./Datenschutz.vue?vue&type=script&lang=ts"
export * from "./Datenschutz.vue?vue&type=script&lang=ts"

import exportComponent from "/home/tristobombo/PHPStormProjects/ITW-webapp-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__